import { CategoryHelper } from './../helper/categoryTransformHelper';
import { AttributeHelper } from './../../catalog/product/helper/attributeHelper';

import { Category } from './../category.type';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { Util } from '../../../utils/util';
import { Observable } from 'rxjs';
import { CategoryAttributes } from '../model/categoryAttributes';
import { ChannelService } from './channel.service';
import { LocalService } from '../../../services/storage/local.service';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  constructor(
    private readonly http: HttpClient,
    private readonly channelService: ChannelService,
    private readonly localeService: LocalService,
  ) {}

  getCategories(key = null) {
    return this.http.get<Category[]>(environment.api_url + 'categories').pipe(
      map((e: Category[]) => {
        const categories = CategoryHelper.transform(e, key);
        this.localeService.setItem('categories', JSON.stringify(categories));
        return categories;
      }),
    );
  }

  getAttributes(id, locales, locale) {
    const params = new URLSearchParams({ categoryId: id?.toString() });
    const defaultLocale = this.channelService.getSelectedLocale();
    return this.http
      .get<CategoryAttributes>(`${environment.api_url}attributes?${params.toString()}`)
      .pipe(
        map((e) =>
          AttributeHelper.getTypologyAttributes(
            e,
            locales,
            locale,
            defaultLocale,
          ),
        ),
      );
  }

  getAttributesPaginated(data) {
    return this.http.post(`${environment.api_url}mapping/attributes/paginated`, data);
  }

  getAttributesByLocale(id, locale) {
    const params = new URLSearchParams({ categoryId: id?.toString() });
    return this.http
      .get<CategoryAttributes>(`${environment.api_url}attributes?${params.toString()}`)
      .pipe(
        map((e) =>
          AttributeHelper.getTypologyAttributes(
            e,
            [locale],
            locale,
            null,
            false
          ),
        ),
      );
  }

  getAttributesByCategoryId(id: number): Observable<CategoryAttributes> {
    const params = new URLSearchParams({ categoryId: id?.toString() });

    return this.http.get<CategoryAttributes>(`${environment.api_url}attributes?${params.toString()}`);
  }

  getCaterogyByLocale(categories, locale: string) {
    return CategoryHelper.filterTreeByLocale(categories, locale);
  }

  getCaterogyByLocales(categories, locales) {
    return CategoryHelper.filterTreeByLocales(categories, locales);
  }

  downloadTemplate(channel, locales, defaultLocale, categories: Category[]) {
    const ids = categories.map((e) => {
      return { categoryId: e.categoryId, categoryBreadCrumb: e.categoryBreadcrumbLoc };
    });
    const headers = {
      channel: channel,
      locales: locales,
      defaultLocale: defaultLocale,
      categories: ids,
    };
    return this.http
      .post(environment.api_url + 'export/product/template', headers, {
        observe: 'response',
        responseType: 'blob',
      })
      .pipe(
        map((response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('content-disposition');
          let filename = 'products.xlsx';
          if (contentDisposition) {
            filename = contentDisposition.split('=')[1];

            // Trim any leading or trailing whitespace
            filename = filename.trim();
          }

          Util.downloadXls(response.body, filename);
        }),
      );
  }

  getLookupValues(attributeCode, locale) {
    let params = new HttpParams().set('attributeCode', attributeCode).set('locale', locale);
    return this.http.get(`${environment.api_url}taxonomy/values`, {params});
  }
}
